import http from '@/http'

const PATH = '/customers'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listCustomers (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number}} data
     * @returns {Promise<void>}
     */
    async showCustomer (data) {
        try {
            const response = await http.get(`${PATH}/${data.customerId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listPropertyHistory ({customerId, params}) {
        try {
            const response = await http.get(`${PATH}/${customerId}/property-history`, {
                params
            })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async updateProperty ({customerId, data}) {
        try {
            const response = await http.put(`${PATH}/${customerId}/property-history/update`, {...data})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number}} data
     * @returns {Promise<void>}
     */
    async listCustomerMetrics ({customerId}) {
        try {
            const response = await http.get(`${PATH}/${customerId}/metrics`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listTypes (params) {
        try {
            const response = await http.get(`${PATH}/types`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listEmployeeCounts (params) {
        try {
            const response = await http.get(`${PATH}/employee-counts`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listIndustryTypes (params) {
        try {
            const response = await http.get(`${PATH}/industry-types`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listAccountManagers(params) {
        try {
            const response = await http.get(`${PATH}/account-managers`, { params })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listAccountManagersFull(params) {
        try {
            const response = await http.get(`${PATH}/full-managers`, { params })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customer_ids: [], cam_id: number}} data
     * @returns {Promise<void>}
     */
    async reallocateCustomers (data) {
        try {
            const response = await http.put(`${PATH}/reallocate`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
